import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'
import { Icon } from '@src/elements/icon/icon'
import { Builder } from '@src/routes/content/components/builder'
import { WorkoutName } from '@src/routes/content/components/workout-builder/workout-name'
import { WorkoutTypeSettings } from '@src/routes/content/components/workout-builder/workout-type'
import { WorkoutContent } from '@src/routes/content/components/workout-builder/workout-content'
import { WorkoutComposition } from '@src/routes/content/components/workout-builder/workout-composition'
import { Button } from '@src/elements/button/button'
import { PrintExercises } from '@src/components/print/print-exercises'
import WorkoutData from '@src/data/workout-data'
import { WorkoutService } from '@src/service/workout'
import camelcaseKeys from 'camelcase-keys'
import { LoadingScreen } from '@src/components/loading-screen/loading-screen/loading-screen'

import '@src/routes/content/components/workout-viewer/workout-viewer.sass'

@Component({
  computed: {
    workout () {
      return this.$store.state.new_workout
    }
  }
})
export class WorkoutViewer extends Vue {

  protected workout: WorkoutData
  private showPrintExercises: boolean = false
  private service: WorkoutService = new WorkoutService()
  private loading = true

  private printMediaQueryList: MediaQueryList

  created () {
    // after print, reset workout to be printed
    window.addEventListener('afterprint', this.resetPrint)
    this.printMediaQueryList = window.matchMedia('print')
    this.printMediaQueryList.addListener(this.onPrintMediaChange)

    return this.loadWorkout()
  }

  beforeDestroy () {
    window.removeEventListener('afterprint', this.resetPrint)
    this.printMediaQueryList.removeListener(this.onPrintMediaChange)
  }

  resetPrint () {
    this.showPrintExercises = false
  }

  onPrintMediaChange (mql: MediaQueryListEvent) {
    if (!mql.matches) {
      this.resetPrint()
    }
  }

  async loadWorkout () {
    if (this.$route.params.id) {
      let workoutId = parseInt(this.$route.params.id, 10)
      this.service.getWorkout(workoutId)
        .then(response => this.onRetrieveWorkoutSuccessful(response))
        .catch(async error => {
          console.error('failed to retrieve workout', error)
          await this.$store.dispatch('removeNewWorkout')
          this.loading = false
        })
    }
  }

  async onRetrieveWorkoutSuccessful (response) {
    let exercises: any[] = response.workout.workout_exercises ? this.service.formatExercisesFromServer(response.workout.workout_exercises) : []

    let workout = new WorkoutData(camelcaseKeys(response.workout, { deep: true }))
    await this.$store.dispatch('setSelectedWorkout', { workout: workout, exercises: exercises })
    this.loading = false
  }

  render (h: CreateElement) {
    return this.loading ? <LoadingScreen/> : <Builder cssClass='workout-builder workout-viewer'>
      <WorkoutName slot='topLeft' disabled={true} />

      <div slot='topMiddle'>
        <WorkoutTypeSettings />
      </div>

      <div slot='topRight'>
        <Button class='print-exercises' type='remove' click={this.printWorkoutExercises} ref='printBtn' icon={'util/print'} label={this.$t('PRINT')} />
      </div>

      <div onClick={this.exit} slot='close'><Icon name='util/close-circled' /></div>

      <WorkoutContent slot='builder' disableEdit={true}/>

      <WorkoutComposition slot={'composition'} showAssistant={false} />

      {this.showPrintExercises ? <PrintExercises exercises={this.workout.workoutExercises.map((woExercise) => woExercise.exercise)} workoutName={this.workout.name} /> : ''}
    </Builder>
  }

  printWorkoutExercises () {
    this.showPrintExercises = true
  }

  exit () {
    this.$router.go(-1)
  }
}
